module.exports = __webpack_public_path__ + "static/video2-329f5974a316f508a50cc1a64e237477.mp4";